import type { SubscriptionRecord } from './types';
import { nativeVipProTierForProductId } from './vipProProducts';

/** A member's own plan when it is VIP or Pro. Legacy Premium is null. */
export type MemberPlanTier = 'vip' | 'pro';

export function memberPlanTierFromRecord(
  record: Pick<SubscriptionRecord, 'plan_tier'> | null | undefined,
): MemberPlanTier | null {
  const tier = record?.plan_tier;
  return tier === 'vip' || tier === 'pro' ? tier : null;
}

/**
 * The member's plan from what they bought: the app store product first
 * (jp_vip_* / jp_pro_*, known the moment the store answers), then the
 * subscription row (web Stripe buyers, and app buyers on the website).
 */
export function memberPlanTierFor({
  productIdentifier,
  record,
}: {
  productIdentifier: string | null | undefined;
  record: Pick<SubscriptionRecord, 'plan_tier'> | null | undefined;
}): MemberPlanTier | null {
  return nativeVipProTierForProductId(productIdentifier) ?? memberPlanTierFromRecord(record);
}

/**
 * The plan name a member sees for their own membership. Only a VIP or Pro
 * purchase changes it, so every legacy Premium member keeps seeing Premium
 * and is never told to switch.
 */
export function memberPlanName(tier: MemberPlanTier | null | undefined): 'VIP' | 'Pro' | 'Premium' {
  if (tier === 'vip') return 'VIP';
  if (tier === 'pro') return 'Pro';
  return 'Premium';
}
